import { EmpathizeState } from '../../../models';
import { EMPATHIZE_MUTATIONS_KEYS } from '../empathize.const';
import { EmpathizeMutation } from '../empathize.interfaces';

export class SaveEmpathizeResponseMutation implements EmpathizeMutation {
  mutations = {
    [EMPATHIZE_MUTATIONS_KEYS.saveEmpathizeResponse]: (localState: EmpathizeState, empathizeResponseState: Partial<EmpathizeState>) => {
      Object.assign(localState, empathizeResponseState);
      localState.selectedIndex = -1;
    }
  };
}
